import { useNavigate, useParams } from "react-router";

import type { PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetOptionEditPageParams = () => {
	const { hotelID, optionID } = useParams<ParamParseKey<typeof PATHS.HOTEL.ITEMS.OPTION.EDIT.OPTIONS_ID.DEFAULT>>();

	const navigate = useNavigate();
	if (!(hotelID && optionID)) {
		navigate("/");
	}

	return {
		hotelID: hotelID!,
		optionID: optionID!,
	};
};
